
import React, {useState,useEffect,useCallback} from 'react'
import useForm from './useForm';
import Modal from '../Modal/Modal';
// import Modal from '@material-ui/core/Modal';
import dataServices from "../../common/dataServices";
import * as Constants from '../../common/Constants';

const Form = React.memo(props =>{

   const stateSchema = {
     Fields:{
          Title: {value: 'הודעה מדף צור קשר',error:''},
          MODFirstName: { value: '',error:'' },
          //MODFamilyName: { value: '',error:''},
          MODPhoneNumber: { value: '',error:''},
          MODEMail: { value: '',error:''},
          MODComments: { value: '',error:''},
          MODAdress:{ value: '',error:''},
          MODCompany:{value:'',error:''}
     },
    MailTo: '',//props.mailTo,
    type: Constants.CreateNewItemContactUs,
    webUrl:  props.mainURL

    //todo MailFormat{}
  };
  useEffect(()=>{
    //console.log("_spPageContextInfo.webServerRelativeUrl.indexOf('/en') ",_spPageContextInfo.webServerRelativeUrl.indexOf('/en'));
  },[]);
  const [showModal,setShowModal] = useState(false);
  const [isSucc,setIsSucc] = useState(false);
  const [loading,setLoading]= useState(false);
  const [firstName,setFirstName]= useState('');

  // Define your validationStateSchema
  // Note: validationStateSchema and stateSchema property
  // should be the same in-order validation works!
  const validationStateSchema = {
    Title: {
      required: false,
    },
    MODFirstName: {
      required: true,
      validator: {
        regEx:/^[a-zA-Z\u0590-\u05ff]+\s?[a-zA-Z\u0590-\u05ff][a-zA-Z\u0590-\u05ff]+$/,
        error:  CreateDicLanguages().MODNameValid,
      },
    },
    // MODFamilyName: {
    //   required: true,
    //   validator: {
    //     regEx: /^[a-zA-Z\u0590-\u05ff]+$/,
    //     error: 'Invalid last name format.',
    //   },
    // },
    MODPhoneNumber: {
      required: true,
      validator: {
        regEx:/^\+?(972|0)?(\-)?0?(([23489]{1}\d{7})|[5]{1}\d{8})$/,
        error:  CreateDicLanguages().MODPhoneValid,
      },
    },
  MODEMail: {
      required: true,
        validator: {
          regEx:  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
          error: CreateDicLanguages().MODEMailValid
          ,
        },
      },
      MODComments: {
        required: true,
      },
      MODAdress: {
        required: false,
      },
      MODCompany: {
        required: false,
      },

  };


   function onSubmitForm(state) {
    
    setLoading(true);
    setFirstName(state.Fields.MODFirstName.value);
      const res = dataServices.setItems(state).then(response=>{
                setIsSucc(true);
                setShowModal(true);
                setLoading(false);
            })
            .catch((error)=>
            {
                setIsSucc(false);
                setShowModal(true);
                setLoading(false);
            });
  };
  
  function CreateDicLanguages(){
    var dic ={};
    dic.he={};
    dic.en={};
    dic.ar={};
    dic.he["MODFirstName"]="שם מלא";
    dic.he["MODPhoneNumber"] ="טלפון";
    dic.he["MODEMail"]="דוא'ל";
    dic.he["MODEMailValid"]='דוא"ל אינו חוקי';
    dic.he["MODPhoneValid"]='תבנית טלפון לא תקינה';
    dic.he["MODNameValid"]='שם לא תקין';
    dic.he["MODComments"] = "מהות הפנייה";
    dic.he["MODCompany"] = "ארגון";
    dic.he["MODAdress"] = "כתובת";
    dic.he["requiredFields1"] = "השדות המסומנים בכוכבית";
    dic.he["requiredFields2"] = "הינם שדות חובה";
    dic.he["submit"] = "שליחה";
    dic.he["ContactUsTitle"] ="צור קשר";
    dic.he["ContactUsSubTitle"] = Constants.ContactUsTitleHENew;
    dic.he["ContactUsForm"] = "טופס צור קשר";

    dic.en["MODFirstName"]="Full name";
    dic.en["MODPhoneNumber"]= "Phone number";
    dic.en["MODEMail"] = "E-mail";
    dic.en["MODEMailValid"]='E-mail address not valid';
    dic.en["MODPhoneValid"]='Phone number not valid';
    dic.en["MODNameValid"]='Name format not valid';
    dic.en["MODComments"] = "Description";
    dic.en["MODCompany"] = "Organization";
    dic.en["MODAddress"] = "Address";
    dic.en["requiredFields1"] = "Fields marked with an asterisk";
    dic.en["requiredFields2"] = "are mandatory";
    dic.en["submit"] = "Submit";
    dic.en["ContactUsTitle"] = "Contact Us";
    //dic.en["ContactUsSubTitle"] = "Please Leave your details and we will contact you";
    dic.en["ContactUsSubTitle"] = Constants.ContactUsTitleENNew;
    dic.en["ContactUsForm"] = "Conact us Form";
    
    dic.ar["MODFirstName"]="الاسم الكامل";
    dic.ar["MODPhoneNumber"]= "رقم الهاتف";
    dic.ar["MODEMail"] = "البريد الإلكتروني";
    dic.ar["MODEMailValid"]='عنوان البريد الإلكتروني غير صالح';
    dic.ar["MODPhoneValid"]='رقم الهاتف غير صالح';
    dic.ar["MODNameValid"]='تنسيق الاسم غير صالح';
    dic.ar["MODComments"] = "تفاصيل الاستفسار";
    dic.ar["MODCompany"] = "المنظمة";
    dic.ar["MODAddress"] = "العنوان";
    dic.ar["requiredFields1"] = "الحقول الموسومة بالنجمة";
    dic.ar["requiredFields2"] = "إلزامية";
    dic.ar["submit"] = "الإرسال";
    dic.ar["ContactUsTitle"] = "الاتصال بنا";
    //dic.ar["ContactUsSubTitle"] ="يرجى ترك تفاصيلك لنعاود الاتصال بك";
    dic.ar["ContactUsSubTitle"] = Constants.ContactUsTitleARNew;
    dic.ar["ContactUsForm"] = "Conact us Form";
    if(_spPageContextInfo.webServerRelativeUrl.toLowerCase().indexOf('/he')> -1)
    {
      return dic.he;
    }
    else if(_spPageContextInfo.webServerRelativeUrl.toLowerCase().indexOf('/ar')> -1){
      return dic.ar;
    }
      else{
      return dic.en;
    }

  }

  function handleOnClose (){
      setShowModal(false);
    }

const { state, handleOnChange, handleOnSubmit, disable } = useForm(
    stateSchema,
    validationStateSchema,
    onSubmitForm,
  );
const errorStyle = {
    color: '#ff6363',
    fontSize: '16px'
    ,lineHeight:'15px'
    ,margin:'5px 0 5px'
    ,border: 'solid thin red'
  };
return (
    <div className='form-contactus col-12'>
       {loading &&
       <div className="centerIcon">
          <i className="fas fa-spinner fa-spin"></i>
        </div>
        }
       
       <Modal  show={showModal} isSucc={isSucc}  data={firstName} onClose={handleOnClose}/>
       <div className={'wp-title col-10 '}>{CreateDicLanguages().ContactUsTitle}</div>

      <div className='form-contactus-container'>
      <fieldset legend={CreateDicLanguages().ContactUsForm}  tabIndex="0"  role="contact us group" className="col-12 col-md-7">
       <form className="col-12 col-md-12 ContactUsForm" data-style="display:flex"  onSubmit={handleOnSubmit}   role="form">
        <div className="dvCUTitle">{CreateDicLanguages().ContactUsSubTitle}</div>
        <div className="col-12 col-md-12  cu-field">

            <input
            id={'contactus_form_firstname'}
              type="text"
              name="MODFirstName"
              className="input-background"
              value={state.Fields["MODFirstName"].value}
              onChange={handleOnChange}
              placeholder={`${CreateDicLanguages().MODFirstName} *`}
              className={'contactus-input' && state.Fields["MODFirstName"].error && ' error-border'}
              title={CreateDicLanguages().MODFirstName}
            //  aria-labeledby={CreateDicLanguages().MODFirstName}
              aria-label={CreateDicLanguages().MODFirstName}
              aria-describedby={"error_contactus_form_firstname"}
              aria-invalid={state.Fields["MODFirstName"].error  ? 'true':'false'}

              aria-required={validationStateSchema["MODFirstName"].required}
            />

          {state.Fields["MODFirstName"].error && <p id={"error_contactus_form_firstname"}  style={errorStyle}>{state.Fields["MODFirstName"].error}</p>}
        </div>
     
         <div className="col-12 col-md-12  cu-field ">
     
            <input
            id={'contactus_form_phone'}
              type="tel"
              name="MODPhoneNumber"
            className="input-background"
              value={state.Fields["MODPhoneNumber"].value}
              onChange={handleOnChange}
              placeholder={`${CreateDicLanguages().MODPhoneNumber} *`}
              className={'contactus-input' && state.Fields["MODPhoneNumber"].error && ' error-border'}
              title={CreateDicLanguages().MODPhoneNumber}
         //     aria-labeledby={CreateDicLanguages().MODPhoneNumber}
              aria-label={CreateDicLanguages().MODPhoneNumber}
              aria-describedby={"error_contactus_form_phone"}
              aria-invalid={state.Fields["MODPhoneNumber"].error  ? 'true':'false'}

              aria-required={validationStateSchema["MODPhoneNumber"].required}
            />

          {state.Fields["MODPhoneNumber"].error && <p  id={"error_contactus_form_phone"}  style={errorStyle}>{state.Fields["MODPhoneNumber"].error}</p>}
        </div>
          <div className="col-12 col-md-12  cu-field">

            <input
            id={'contactus_form_email'}
              type="email"
              name="MODEMail"
             
              value={state.Fields["MODEMail"].value}
              onChange={handleOnChange}
              placeholder={CreateDicLanguages().MODEMail +'*'}
              className={'contactus-input' && state.Fields["MODEMail"].error && ' error-border'}
              title={CreateDicLanguages().MODEMail}
          //    aria-labeledby={CreateDicLanguages().MODEMail}
              aria-label={CreateDicLanguages().MODEMail}
              aria-describedby={"error_contactus_form_email"}
              aria-invalid={state.Fields["MODEMail"].error  ? 'true':'false'}
              aria-required={true}
            />
            {state.Fields["MODEMail"].error && <p id={"error_contactus_form_email"} style={errorStyle}>{state.Fields["MODEMail"].error}</p>}
        </div>
           <div className="col-12 col-md-12 cu-field">

            <textarea
            id={'contactus_form_comment'}
              rows="10"
              name="MODComments"
              className={state.Fields["MODComments"].error && 'error-border'}
              value={state.Fields["MODComments"].value}
              onChange={handleOnChange}
              placeholder={CreateDicLanguages().MODComments +'*'}
              title={CreateDicLanguages().MODComments}
           //   aria-labeledby={CreateDicLanguages().MODComments}
              aria-label={CreateDicLanguages().MODComments}
              aria-describedby={"error_contactus_form_comment"}
              aria-invalid={state.Fields["MODComments"].error  ? 'true':'false'}
            />

          {state.Fields["MODComments"].error && <p id={"error_contactus_form_comment"} style={errorStyle}>{state.Fields["MODComments"].error}</p>}
        </div>
   
        <div className="col-12 col-md-12 cu-field submitWrap">

        <button type="submit" name="submit" text="שליחה"
         value="שליחה"
         title={'submit'}
     //    aria-labeledby={'submit'}
         aria-label={'submit'}
          className=" submitBut btn btn-outline-secondary">{CreateDicLanguages().submit}
          {_spPageContextInfo.webServerRelativeUrl.indexOf('/en')> -1 ?<i className={'fas fa-arrow-right thin-icon'}></i> :<i className={'fas fa-arrow-left thin-icon'}></i> }
          </button>
         </div>

      </form>
      </fieldset>
      <div className={'col-10 col-md-5'}>
        <div className={'sub-wrapper'}>
          <div className={'col-12 col-md-12 sub-title'}>{CreateDicLanguages().MODPhoneNumber}</div>
          <div className={'col-12 col-md-12 contactus-text mt-2'}>{props.title}</div>
          </div>
          <div className={'sub-wrapper mt-4'}>
          <div className={'col-12 col-md-12 sub-title'}>{CreateDicLanguages().MODEMail}</div>
          <div className={'col-12 col-md-12  contactus-text mt-2'}><a href={`mailto:${props.link}`}>{props.link}</a></div>
          </div>
        </div>
        </div>
    </div>
  );
});
export default Form;

